import styled from "styled-components";

export const UsersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 0;
`;

export const PermissionsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const UserCellContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

export const UserAvatarContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const UserTextContainer = styled.div`
  display: flex;
  align-items: center;
`;

